import types from '../../../../types';

export default {
  [types.STORE_INVOICE_ITEMS]: (state, payload) => {
    state.items = [...state.items, ...payload.items];
    state.count = payload.count;
    state.entity = payload.entity;
  },
  [types.CLEAR_INVOICE_ITEMS]: (state) => {
    state.items = [];
  },
};
